import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { SrmService } from '../../../../../../shared/service/srm.service';

@Component({
  selector: 'app-section-management',
  templateUrl: './section-management.component.html',
  styleUrls: ['./section-management.component.scss']
})
export class SectionManagementComponent implements OnInit {

  apps: any[] = [];
  public dataSource = new MatTableDataSource([]);
  public displayedColumns = ['title', 'action']
  constructor(
    private spinner: Spinner,
    private srmService: SrmService,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
   }

  ngOnInit() {
    this.getListApplication();
  }

  public getListApplication() {
    this.spinner.show();
    this.srmService.getSections().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.dataSource.data = res.data;
        this.apps = res.data;
      }
    });
  }

  public add() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_SECTION]);
  }

  public editSection(id) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-section', id]);
  }

  public deleteSection(id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_SECTION,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.srmService.deleteSections(id).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_SECTION_SUCCESS);
            this.spinner.show();
            location.reload();
          }
        });
      }
    });
  }

}
